import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import ContactsIcon from '@mui/icons-material/Contacts';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import FeedbackIcon from '@mui/icons-material/Feedback';
import CalendarMonthIcon from '@mui/icons-material/CalendarToday';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import EmailIcon from '@mui/icons-material/Email';
import GroupsIcon from '@mui/icons-material/Groups';
import { RouteInformation } from '../../shared/constants/RouteInformation';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import type { ReactNode } from 'react';
import { neutralPalette } from '../../theme/palette';
import { TrackerDataType } from '../../shared/constants/constants';
import { getSidebarLogIconComponent } from '../../shared/constants/logIcons';

const ServiceLogIcon = getSidebarLogIconComponent(TrackerDataType.SERVICE);

/**
 * For addon page sidebar items, must include `addonControl` property.
 *
 * `addonControl` = 'collaboration' | 'engagement' | 'trackerAI' (update if more addons)
 */
export type SidebarItem = {
  title: string;
  icon: ReactNode;
  iconColor: string;
  link: string;
  accessibility: number;
  addonControl?: 'collaboration' | 'engagement' | 'contentLog' | 'trackerAI';
};

export const SidebarItems: SidebarItem[] = [
  {
    title: 'Service Log',
    icon: <ServiceLogIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.serviceLog.path,
    accessibility: RouteInformation.serviceLog.privilegeRequirement,
  },
  {
    title: 'Media Interactions',
    icon: <RecordVoiceOverIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.mediaInteraction.path,
    accessibility: RouteInformation.mediaInteraction.privilegeRequirement,
  },
  {
    title: 'Engagement Log',
    icon: <HandshakeOutlinedIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.engagementLog.path,
    accessibility: RouteInformation.engagementLog.privilegeRequirement,
    addonControl: 'engagement',
  },
  {
    title: 'Content Log',
    icon: <DescriptionIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.contentLog.path,
    accessibility: RouteInformation.contentLog.privilegeRequirement,
    addonControl: 'contentLog',
  },
  {
    title: 'Calendar',
    icon: <CalendarMonthIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.calendar.path,
    accessibility: RouteInformation.calendar.privilegeRequirement,
  },
  {
    title: 'Contacts',
    icon: <ContactsIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.contacts.path,
    accessibility: RouteInformation.contacts.privilegeRequirement,
  },
  {
    title: 'Team Analytics',
    icon: <QueryStatsOutlinedIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.teamAnalytics.path,
    accessibility: RouteInformation.teamAnalytics.privilegeRequirement,
  },
  {
    title: 'Custom Analytics',
    icon: <AnalyticsIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.customAnalytics.path,
    accessibility: RouteInformation.customAnalytics.privilegeRequirement,
  },
  {
    title: 'Report Generation',
    icon: <EmailIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.report.path,
    accessibility: RouteInformation.report.privilegeRequirement,
  },
  {
    title: 'Collaborate',
    icon: <GroupsIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.collaboration.path,
    accessibility: RouteInformation.collaboration.privilegeRequirement,
    addonControl: 'collaboration',
  },
  {
    title: 'Admin',
    icon: <AdminPanelSettingsIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.admin.path,
    accessibility: RouteInformation.admin.privilegeRequirement,
  },
  {
    title: 'Broadsight Admin',
    icon: <SupervisorAccountIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.tenants.path,
    accessibility: RouteInformation.tenants.privilegeRequirement,
  },
  {
    title: 'Feedback',
    icon: <FeedbackIcon />,
    iconColor: neutralPalette.textHelper,
    link: RouteInformation.feedback.path,
    accessibility: RouteInformation.feedback.privilegeRequirement,
  },
];
